<template>
  <div class="m-4 text-left pl-4 pr-4" style="background-color: white !important">
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <b-button v-if="!edicionLinkUsuario" class="mt-4 ml-0" variant="outline-ligth"  @click="mostrarTipoHistoriaClinica(0)">
            <b-icon icon="arrow-left-circle"></b-icon>
          </b-button>
          <p
        class="solo-primera-mayus mt-4"
        style="font-size: 2em; font-family: 'Silene'"
      >
        Historia clínica infantil
      </p>
      </div>
      
      <img
        src="@/assets/Imagotipo azul_b.png"
        alt=""
        style="width: 10em; height: 4em"
      />
    </div>

    <div
      class="p-4 mt-3 mb-4"
      style="
        font-size: 0.85em;
        line-height: 2;
        background-color: #fbf3de;
        border-radius: 10px;
        padding-left: 3% !important;
      "
    >
     <DatosCabecera
        :persona="infoPaciente.persona"      
      ></DatosCabecera>
    </div>
<b-row v-if="!edicionLinkUsuario" >
      <b-col sm="12" md="12" lg="6" xl="6">
        <b-alert v-if="copiado" variant="success" show
          >Se copió el enlace en tu portapapeles</b-alert
        >
<!--        <patient-journey-v2 v-else
                            :idPaciente="idPaciente"
                            :hc=true
        ></patient-journey-v2>-->
      </b-col>
      <b-col sm="12" md="12" lg="6" xl="6">
        Link de historia clínica:
        <b-button variant="link" @click="copiar" style="text-transform: none !important; width: 50%;">{{ linkEnlace }}</b-button>
      </b-col>
    </b-row>
    <hr />

    <b-form v-on:submit.prevent="enviarFormulario" class="mt-4">
      <div class="d-flex">
        <img class="img_subtitle" src="@/assets/hc/datos.png" alt="" />
        <p class="subtitle">Datos del paciente</p>
      </div>

      <DatosPacienteNinoHC
        :persona="infoPaciente.persona"
        :listaEnterarse="listaEnterarse"
        :listaSexo="listaSexo"
        :cargandoPlanes.sync="cargandoPlanes"
        :cargandoCercania.sync="cargandoCercania"
        :cargandoConfianza.sync="cargandoConfianza"
        :cargandoMedio.sync="cargandoMedio"
       
      ></DatosPacienteNinoHC>

      <hr class="mt-4"/>

      <div class="d-flex mt-4">
        <img class="img_subtitle" src="@/assets/hc/datos.png" alt="" />
        <p class="subtitle">¿Cómo te enteraste de dentalia?</p>
      </div>

      <ComoTeEnterasteNino
        :persona="infoPaciente.persona"
        :listaEnterarse="listaEnterarse"
        :listaSexo="listaSexo"
        :cargandoPlanes.sync="cargandoPlanes"
        :cargandoCercania.sync="cargandoCercania"
        :cargandoConfianza.sync="cargandoConfianza"
        :cargandoMedio.sync="cargandoMedio"
      ></ComoTeEnterasteNino>

      <hr />

      <div class="d-flex">
        <img class="img_subtitle" src="@/assets/hc/datos.png" alt="" />
        <p class="subtitle">Datos del padre o tutor</p>
      </div>

       <div v-if="edicionLinkUsuario">
          <datos-padre-historia-nino
          v-if="headers"
            :infoPaciente="infoPaciente"
            :listaEnterarse="listaEnterarse"
            :listaParentesco="listaParentesco"
            :urlBase="urlBase"
            :headers="headers"
            :edicionLinkUsuario="edicionLinkUsuario"
          />
        </div>
        <div v-else>
          <datos-padre-historia-nino
            :infoPaciente="infoPaciente"
            :listaEnterarse="listaEnterarse"
            :listaParentesco="listaParentesco"
            :urlBase="urlBase"
            :headers="headers"
            :edicionLinkUsuario="edicionLinkUsuario"
          />
        </div>
      

      <hr />

      <div class="d-flex">
        <img class="img_subtitle" src="@/assets/hc/datos.png" alt="" />
        <p class="subtitle">Datos médicos</p>
      </div>

      <DatosMedicos :listaFormulario.sync="listaFormulario"></DatosMedicos>

      <hr />

      <div class="text-center mt-5">
        <p class="text-justify">
          De conformidad con la norma oficial mexicana número NOM-004-SSA3-2012,
          los expedientes clínicos son propiedad del prestador de servicios que
          los genera, en ese tenor, no se podrán entregar constancias o
          documentos que forman parte del mismo, ni tampoco copia alguna,
          incluyendo estudios, radiografías, modelos, etc. El paciente como
          propietario de la información que proporciona para su atención
          odontológica y al ser beneficiario de los servicios médicos, tiene
          derecho de titularidad sobre la información para la protección de su
          salud, así como para la protección de la confidencialidad de sus datos
          en términos de nuestro aviso de privacidad. Manifiesto que todos los
          datos en la presente solicitud fueron declarados por mí, son verídicos
          y correctos.
        </p>
        <div class="d-flex justify-content-center mt-3 mi-componente">
          <p class="mr-2 semibold">He leído y acepto el aviso de privacidad.</p>
          <b-form-checkbox
            class="mi-checkbox-unico"
            name="terminos"
            v-model="infoPaciente.persona.aceptaAvisoPrivacidad"
            :state="
              infoPaciente.persona.aceptaAvisoPrivacidad != '' &&
              infoPaciente.persona.aceptaAvisoPrivacidad != null
            "
            required
          >
          </b-form-checkbox>
        </div>
        <div class="text-center">
          <b-button
            class="mt-4 mb-4 pl-3 pr-3"
            type="submit"
            pill
            variant="primary"
            style="height: 2.5em"
            v-if="!enviando && (activarGuardar || edicionLinkUsuario)"
          >
            <p style="font-weight: 600; color: white !important">Guardar</p>
          </b-button>
          <b-button
            variant="primary"
            v-show="enviando"
            disabled
            style="height: 2.5em"
          >
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import VueNotifications from "vue-notifications";
import { LoginService } from "@/apiServices/login/LoginService";
import moment from "moment/moment";
import DatosCabecera from "./DatosCabecera.vue";
import DatosPacienteNinoHC from "@/views/perfilPacientes/historialClinica/DatosPacienteNinoHC";
import DatosPadreHistoriaNino from "@/views/perfilPacientes/historialClinica/HistoriaNinoComponentes/DatosPadreHistoriaNino";
import ComoTeEnterasteNino from "./HistoriaNinoComponentes/ComoTeEnterasteNino.vue";
import DatosMedicos from "./DatosMedicos.vue";
export default {
  name: "HistoriaNinoV2",
  components: {
    DatosPacienteNinoHC,
    DatosPadreHistoriaNino,
    ComoTeEnterasteNino,
    DatosMedicos,
    DatosCabecera
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loginService: new LoginService(),
    headers: null,
    urlBase: null,
    copiado: false,
    paciente: null,
    existeFirma: false,
    existeCorreo: false,
    existeTelefono: false,
    existeCasa: false,
    existeTrabajo: false,
    idPaciente: null,
    nombrePlan: "",
    idPlan: null,
    listaConfianza: [],
    listaEnterarse: [],
    listaCercania: [],
    listaParentesco: [],
    listaDolor: [],
    listaSexo: [],
    infoPaciente: {
      persona: {
        idPersona: null,
        apellidoMaterno: "",
        apellidoPaterno: "",
        nombre: "",
        fechaNacimiento: "",
        sexo: "",
        correo: "",
        telefono: "",
        casa: "",
        trabajo: "",
        idClinica: "",
      },

      tutor: {
        idPacienteTutor: null,
        idPersona: null,
        nombreTutor: null,
        idParentesco: null,
        correo: null,
        domicilio: null,
        telefono: null,
        casa: null,
        trabajo: null,
        horarioContactoEntre: null,
        horarioContactoALas: null,
      },
    },
    listaFormulario: [],
    listaEnviar: [],
    cargandoPlanes: true,
    cargandoDatosForm: true,
    cargandoMedio: true,
    cargandoCercania: true,
    cargandoConfianza: true,
    cargandoDolor: true,
    enviando: false,
    verFirma: false,
    fechaNacimiento: null,
    idPacienteEncrip: null,
    idClinicaEncrip: null,
    idClinicaEncripPer: null,
    fechaActual: null,
  }),
  props: {
    edicionLinkUsuario: Boolean,
    idHistoriaClinica: Number,
    activarGuardar: Boolean,
    idPacienteProp: Number,
    idClinicaProp: Number,
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    if (!this.edicionLinkUsuario) {
      this.idClinicaEncripPer = this.$global.encriptar(
        this.$localStorageService.getIdClinica()
      );
    }

    this.fechaActual = new Date();
    if (!this.edicionLinkUsuario) {
      this.idPaciente = this.$route.params.idPaciente;
      this.idClinica = this.$route.params.idClinica;
    }
    this.urlBase = this.$api;

    if (this.idPaciente === undefined || this.idPaciente === null) {
      this.idPaciente = this.$route.params.id;
    }

    if (!this.edicionLinkUsuario) {
      this.idClinica = this.$localStorageService.getIdClinica();
      this.nombreClinica = this.$localStorageService.getNombreClinica();
      this.idPacienteEncrip = this.$global.encriptar(this.idPaciente);
      this.idClinicaEncrip = this.$global.encriptar(this.idClinica);
    } else {
      await this.generarToken();
      this.idPaciente = this.idPacienteProp;
      this.idClinica = this.idClinicaProp;
    }

    this.traerMedio();
    this.traerFormulario();
    this.traerCercania();
    this.traerParentesco();

    //si no trae datos de la base se colocan los de la sesion
    this.traerPlanes();
    this.vadicionActivarEceClinica();
    this.obtenerListaSexo();
  },
  methods: {
    mostrarTipoHistoriaClinica(tipoHc) {
      this.$emit("mostrarTipoHistoriaClinica", tipoHc);
    },
    async generarToken() {
      try {
        const user = process.env.VUE_APP_ACCESS_HISTORIA_CLINICA_USER;
        const dato = process.env.VUE_APP_ACCESS_HISTORIA_CLINICA_DATE;

        const response = await this.loginService.login(user, dato);
        this.headers = {
          headers: {
            Authorization: response.Authentication,
          },
        };       
      } catch (error) {
        console.error("Error al generar token:", error);
      }
    },

    verificarExisteFirma(value) {
      this.existeFirma = value;
    },
    traerPlanes() {
      this.cargandoPlanes = true;
      const datos = {
        idPaciente: this.idPaciente,
      };
      let urlPlanes = this.urlBase + "paciente/perfiles/obtenerPlanesPaciente";
      console.log("headers traer planes",this.headers)
      this.$http
        .post(urlPlanes, datos, this.headers)
        .then((response) => {
          if (response.data.data) {
            let idPlan = null;
            let nombrePlan = "";
            response.data.data.forEach((plan) => {
              idPlan = plan.id;
              nombrePlan = plan.nombre;
            });
            this.idPlan = idPlan;
            this.nombrePlan = nombrePlan;
            this.cargandoPlanes = false;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
          this.cargandoPlanes = false;
        });
    },
    traerMedio() {
      let urlMedio = this.urlBase + "paciente/catalogo/listaMedio";
      this.$http
        .get(urlMedio, this.headers)
        .then((response) => {
          if (response.data.data) {
            this.listaEnterarse = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargandoMedio = false;
        });
    },

    traerCercania() {
      this.cargandoCercania = true;
      let urlCercania = this.urlBase + "paciente/catalogo/listaCercania";
      this.$http
        .get(urlCercania, this.headers)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idCercania: null,
              descripcion: "Cercania: ",
            });
            this.listaCercania = response.data.data;
            this.cargandoCercania = false;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
          this.cargandoCercania = false;
        });
    },

    traerParentesco() {
      this.cargandoCercania = true;
      let url = this.urlBase + "paciente/catalogo/listaParentesco";
      this.$http
        .get(url, this.headers)
        .then((response) => {
          if (response.data.data) {
            /*response.data.data.unshift({
            idParentesco: null,
            nombre: "Parentesco: ",
          });*/
            this.listaParentesco = response.data.data;
            this.cargandoCercania = false;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
          this.cargandoCercania = false;
        });
    },

    validarSiExistenDatos() {
      if (
        this.infoPaciente.tutor.correo !== null &&
        this.infoPaciente.tutor.correo !== ""
      ) {
        this.existeCorreo = true;
      }
      if (
        this.infoPaciente.tutor.telefono !== null &&
        this.infoPaciente.tutor.telefono !== ""
      ) {
        if (this.infoPaciente.tutor.telefono.replace(/ /g, "").length === 10) {
          this.existeTelefono = true;
        }
      }
      if (
        this.infoPaciente.tutor.casa !== null &&
        this.infoPaciente.tutor.casa !== ""
      ) {
        if (this.infoPaciente.tutor.casa.replace(/ /g, "").length === 10) {
          this.existeCasa = true;
        }
      }
      if (
        this.infoPaciente.tutor.trabajo !== null &&
        this.infoPaciente.tutor.trabajo !== ""
      ) {
        if (this.infoPaciente.tutor.trabajo.replace(/ /g, "").length === 10) {
          this.existeTrabajo = true;
        }
      }
    },
    async traerFormulario() {
      const params = {
        idDenticion: 1,
      };
      const urlForm = this.urlBase + "paciente/hc/obtenerFormulario";

      try {
        const response = await this.$http.post(urlForm, params, this.headers);
        this.listaFormulario = response.data.data;
      } catch (error) {
        console.error("Error al traer el formulario", error);
      } finally {
        this.cargandoDatosForm = false;
      }

      try {
        const responseDatos = await this.traerDatosPaciente();
        await this.tratarDatos(responseDatos);
      } catch (error) {
        console.error("Error al procesar los datos del paciente", error);
      }
    },

    tratarDatos(response) {
      this.listaFormulario.forEach((l) => {
        l.enfermedades.forEach((e) => {
          this.infoPaciente.persona.listEnfermedad.forEach((g) => {
            if (e.idEnfermedadSistemica === g.idEnfermedadSistemica) {
              e.valor = g.valor;
            }
          });
        });
      });

      // persona
      this.infoPaciente.persona.fechaNacimiento = this.$global.traerFechaLocal(
        moment(response.data.data.fechaNacimiento).utc().format("MM/DD/YYYY")
      );

      // historial
      if (response.data.data.historia.idHistoriaClinica == null) {
        this.infoPaciente.historia.fechaModificacion = this.$global.traerFecha();

        if (!this.edicionLinkUsuario) {
          this.infoPaciente.historia.idClinica = this.idClinica;
          this.infoPaciente.historia.nombreClinica = this.nombreClinica;
        }
      }

      this.validarSiExistenDatos();
    },


    async traerDatosPaciente() {
      if (
        this.idHistoriaClinica === undefined ||
        this.idHistoriaClinica === null
      ) {
        this.idHistoriaClinica = 0;
      }

      const urlPaciente =
        this.urlBase +
        "paciente/hc/obtenerDatosParametricosNino?idPaciente=" +
        this.idPaciente +
        "&idHistoriaClinica=" +
        this.idHistoriaClinica;

      try {
        const response = await this.$http.get(urlPaciente, this.headers);

        if (response.data.data) {
          this.infoPaciente.persona = response.data.data;
          this.infoPaciente.tutor = response.data.data.tutor;

          this.infoPaciente.tutor.domicilio =
            this.infoPaciente.tutor.direccionTutor.calle +
            ", " +
            this.infoPaciente.tutor.direccionTutor.colonia +
            ", " +
            this.infoPaciente.tutor.direccionTutor.codigoPostal;

          return response;
        }
      } catch (err) {
        console.error("Error al obtener datos del paciente", err);
      } finally {
        this.idClinicaEncripPer = this.$global.encriptar(
          this.$localStorageService.getIdClinica()
        );
      }

      return null; 
    },

    enviarFormulario() {
      if (!this.validarDatos()) {
        this.guardarEditarhistoria();
      }
    },
    guardarEditarhistoria() {
      this.listaEnviar = [];
      this.fechaNacimiento = this.infoPaciente.persona.fechaNacimiento;

      let formularioValido = true;
      let enfermedadRequerida = [];

      if (this.infoPaciente.tutor !== null) {
        if (
          this.infoPaciente.tutor.idPersona === null ||
          this.infoPaciente.tutor.idParentesco === null
        ) {
          this.$swal({
            icon: "warning",
            html: `Por favor verifique los datos del tutor`,

            confirmButtonColor: "#0e6ba9",
            cancelButtonColor: "#8e8e8e",
            confirmButtonText: "Ok",
            showCancelButton: false,
          });
          return;
        }
      }

      this.listaFormulario.forEach((l) => {
        l.enfermedades.forEach((e) => {
          if (e.valor !== null) {
            this.listaEnviar.push({
              idEnfermedadSistemica: e.idEnfermedadSistemica,
              valor: e.valor,
            });
          } else {
            if (e.valor === null && e.requerido) {
              formularioValido = false;
              enfermedadRequerida.push(e.descripcionEnfermedad);
            }
          }
        });
      });

      if (!formularioValido) {
        this.$swal({
          icon: "warning",
          html: `Falta llenar el campo requerido:</br> <strong> ${enfermedadRequerida} </strong>, </br> Por favor llene todos los campos obligatorios `,

          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Ok",
          showCancelButton: false,
        });
      } else {
        this.infoPaciente.listEnfermedad = this.listaEnviar;

        this.infoPaciente.persona.fechaNacimiento =
          this.infoPaciente.persona.fechaNacimiento;
        this.infoPaciente.persona.fechaNacimiento = this.$moment(
          this.infoPaciente.persona.fechaNacimiento
        );
        if (this.idClinica != null) {
          this.infoPaciente.persona.idClinica = this.edicionLinkUsuario
            ? this.idClinica
            : this.$localStorageService.getIdClinica();
        } else {
          this.infoPaciente.persona.idClinica =
            this.infoPaciente.persona.idClinica;
        }
        this.infoPaciente.persona.edicionLink = this.edicionLinkUsuario
          ? true
          : false;
        this.infoPaciente.persona.esEmergencia = false;

        this.$swal({
          icon: "warning",
          text: "¿Los datos son correctos?",
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Enviar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.enviando = true;
            this.enviarDatos();
          }
        });
      }
    },
    enviarDatos() {
      if (this.infoPaciente.persona.sexo === "MASCULINO") {
        this.infoPaciente.persona.genero = 1;
      } else {
        if (this.infoPaciente.persona.sexo === "FEMENINO") {
          this.infoPaciente.persona.genero = 2;
        } else {
          this.infoPaciente.persona.genero = 3;
        }
      }

      let urlEditar =
        this.urlBase +
        "paciente/historialDinamicoNino?idPaciente=" +
        this.idPaciente;

      this.$http
        .post(urlEditar, this.infoPaciente, this.headers)
        .then((response) => {
          if (response.status === 200) {
            this.enviando = false;
            this.$swal({
              icon: "success",
              text: "Se guardó su historial clínico correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            }).then((aceptar) => {
              if (
                aceptar.value &&
                localStorage.getItem("abrirAgenda") === "true"
              ) {
                this.$router.push({
                  name: "Schedule",
                });
                localStorage.abrirAgenda = false;
              }
            });
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
      this.infoPaciente.persona.fechaNacimiento = this.fechaNacimiento;
    },
    validarDatos() {
      let error = false;
      if (this.infoPaciente.persona.idMedio == null) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar una opción de '¿Cómo te enteraste de dentalia?'",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        error = true;
      }

      return error;
    },

    acomodarDatos() {
      let historial = this.infoPaciente.historia;
      historial.idPaciente = this.idPaciente;

      if (this.edicionLinkUsuario) {
        historial.idClinica = this.infoPaciente.historia.idClinica;
      } else {
        historial.idClinica =
          this.infoPaciente.historia.idClinica != null
            ? this.infoPaciente.historia.idClinica
            : this.idClinica;
      }

      if (this.edicionLinkUsuario) {
        historial.usuarioLogeado = 1;
      } else {
        historial.usuarioLogeado = this.$localStorageService.getIdUsuario();
      }

      return {
        historia: historial,
        persona: {
          casa: this.infoPaciente.persona.casa,
          trabajo: this.infoPaciente.persona.trabajo,
          telefono: this.infoPaciente.persona.telefono,
          correo: this.infoPaciente.persona.correo,
          sexo: this.infoPaciente.persona.sexo,
          facebook: this.infoPaciente.persona.facebook,
          twitter: this.infoPaciente.persona.twitter,
          idPersona: this.infoPaciente.persona.idPersona,
        },
      };
    },
    copiar() {
      var aux = document.createElement("input");
      aux.setAttribute("value", this.linkEnlace);
      document.body.appendChild(aux);
      aux.select();
      aux.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(aux.value);
      document.body.removeChild(aux);
      this.copiado = true;
      setTimeout(() => {
        this.copiado = false;
      }, 2000);
    },
    obtenerListaSexo() {
      let peticion = this.urlBase + "paciente/catalogo/listaSexo";
      this.$http.get(peticion, this.headers).then((response) => {
        this.listaSexo = response.data.data;
      });
    },
    async vadicionActivarEceClinica() {
      if (
        this.infoPaciente.persona.idClinica !== undefined &&
        this.infoPaciente.persona.idClinica !== null
      ) {
        const parametros = { idClinica: this.infoPaciente.persona.idClinica };
        await this.$http
          .post(
            this.$api + "catalogos/obtenerClinicasActivasECE",
            parametros,
            this.headers
          )
          .then((response) => {
            this.verFirma = response.data.data;
          });
      }
    },
    esAlfanumerico(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },

  mounted() {
    /*if (this.infoPaciente.historia.idHistoriaClinica == null) {
        this.infoPaciente.historia.fechaModificacion = this.$global.traerFecha();
  
        if (!this.edicionLinkUsuario) {
          this.infoPaciente.historia.idClinica = this.idClinica;
          this.infoPaciente.historia.nombreClinica = this.nombreClinica;
        }
      }*/
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
  computed: {
    linkEnlace: function () {
      if (this.infoPaciente.persona.idClinica != null) {
        return (
          document.location.origin +
          "/historia/nino/" +
          this.idPacienteEncrip +
          "/*" +
          this.idClinicaEncripPer
        );
      } else {
        return (
          document.location.origin +
          "/historia/nino/" +
          this.idPacienteEncrip +
          "/*" +
          this.idClinicaEncrip
        );
      }
    },
  },
};
</script>
<style scoped>
p{
  margin: 0px;
  padding: 0px;
  color: #0046A2 !important;
}

.solo-primera-mayus {
  text-transform: lowercase !important;
}

.solo-primera-mayus::first-letter {
  text-transform: uppercase !important;
}

.semibold {
  font-weight: 600;
}

.subtitle {
  font-size: 1.5em;
  font-weight: 700;
}

.img_subtitle {
  width: 2.4em;
  height: 2.2em;
  margin-right: 1%;
}

.mi-componente /deep/ .mi-checkbox-unico .custom-control-label::before {
  background-color: transparent !important;
  border: 2px solid #012247 !important;
  width: 1.5em !important;
  height: 1.5em !important;
}

.mi-componente
  /deep/
  .mi-checkbox-unico
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #c4e39b !important;
  border-color: #012247 !important;
}

.mi-componente
  /deep/
  .mi-checkbox-unico
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23012247' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e") !important;
  width: 1.5em !important;
  height: 1.5em !important;
}
</style>
